import { f as fetchHTML } from './fetchHTML-CGNR3V1z.js';
import { Swiper } from './swiper-D_0i_b49.js';
import { N as Navigation } from './navigation-QoQEtHe8.js';
import { P as Pagination } from './pagination-Ror5spP5.js';
import { A as A11y } from './a11y-Bc4Hy9nX.js';
import './parseHTML-Om2c1Ayj.js';
import './utils-oQVxRlcV.js';

class RecommendedProducts extends HTMLElement {
  connectedCallback() {
    this.#fetchRecommendations();
  }

  async #fetchRecommendations() {
    try {
      const html = await fetchHTML(this.dataset.url);

      this.innerHTML = html.querySelector('recommended-products').innerHTML;
      this.#removeLoaders();
      this.#initSwiper();
    } catch (error) {
      console.error(error);
      this.style.display = 'none';
    }
  }

  #removeLoaders() {
    setTimeout(() => {
      this.querySelectorAll('[data-loader]').forEach((loader) => {
        loader.ariaHidden = true;
      });
    }, 50);
  }

  #initSwiper() {
    const swiperEl = this.querySelector('.swiper');
    const pagination = this.querySelector('.swiper-pagination');
    const nextButton = this.querySelector('.swiper-button-next');
    const prevButton = this.querySelector('.swiper-button-prev');

    new Swiper(swiperEl, {
      modules: [A11y, Pagination, Navigation],
      slidesPerView: 1.33,
      spaceBetween: 16,
      pagination: {
        el: pagination,
        type: 'progressbar',
      },
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 16,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
        },
      },
    });
  }
}

customElements.define('recommended-products', RecommendedProducts);
